import React, { useMemo } from "react";
import { Form, Select } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { useQuery } from "@apollo/client";
import { GET_ROLES } from "graphql/query/role-gql";
import Icons from "components/icons";
import { useTranslation } from "components/use-hooks";
import { normalizeStaffWorkerRoleIDs } from "../../helpers/staff-workers-api-helper";


const StaffWorkersRoleSelect = ({
    eventRoles = [],
    form,
    name = "role_id",
    selected = false,
    onChange = () => {},
}) => {
    const translations = useTranslation();
    const eligibleRoleIDs = useMemo(
        () => normalizeStaffWorkerRoleIDs(eventRoles),
        [ eventRoles ]
    );
    const { data, loading } = useQuery(GET_ROLES, {
        skip: !eligibleRoleIDs.length,
        variables: {
            first: eligibleRoleIDs.length,
            page: 1,
            orderBy: [ { column: "LABEL", order: "ASC" } ],
            where: {
                column: "ID",
                operator: "IN",
                value: eligibleRoleIDs,
            },
        },
        fetchPolicy: "cache-and-network",
        nextFetchPolicy: "cache-first",
    });
    const options = useMemo(() => {
        const rolesByID = new Map(
            [ ...eventRoles, ...(data?.roles?.data || []) ]
                .filter(Boolean)
                .map((role) => [ String(role.id), role ])
        );

        return eligibleRoleIDs
            .map((roleID) => ({
                value: roleID,
                label: rolesByID.get(roleID)?.label || roleID,
            }))
            .sort((left, right) => (
                String(left.label).localeCompare(String(right.label)) ||
                left.value.localeCompare(right.value, undefined, { numeric: true })
            ));
    }, [ data, eligibleRoleIDs, eventRoles ]);
    const placeholder = translations[ "TABLES.Column_Title_UserGroup" ] || "User group";

    return (
        <Form.Item name={ name } noStyle>
            <Select
                allowClear
                aria-label={ placeholder }
                clearIcon={ <CloseOutlined /> }
                showArrow
                showSearch
                className={ `staff-workers-filter__role${
                    selected ? " staff-workers-filter__role--chosen staff-filter-control--selected" : ""
                }` }
                dropdownClassName="staff-workers-filter__dropdown"
                filterOption={ (input, option) => (
                    String(option?.label || "").toLowerCase().includes(input.trim().toLowerCase())
                ) }
                loading={ loading }
                options={ options }
                placeholder={ placeholder }
                suffixIcon={ selected ? null : <Icons.Arrow /> }
                onChange={ (value) => {
                    form.setFieldsValue({ [ name ]: value });
                    onChange(value);
                } } />
        </Form.Item>
    );
};

export default StaffWorkersRoleSelect;
